import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';

type CreateContactRequestBody = {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

type FlashyCreateContactResponse = {
  user: {
    contactID: string,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
    babies: boolean,
    communityMember: boolean,
    kids12: boolean,
    dogsOwners: string,
    vacationsType: string,
    travelevel: string,
    createdAt: Date,
  }
}

type RegisterUserRequest = {
  contactID: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

type RegisterUserResponse = {
  user: {
    contactID: string
    firstName: string
    lastName: string
    email: string
    phone: string
    babies: boolean
    communityMember: boolean
    kids12: boolean
    dogsOwners: string
    vacationsType: string
    travelevel: string
    createdAt: Date
  }
}

export class APIService {
  static API_BASE = process.env.REACT_APP_API_SERVER;
  static URL = {
    createFlashyContact: 'api/flashy/createContact',
    createNewUser: 'api/users/createUser',
  };

  constructor(private readonly token?: string) {}

  public async createFlashyContact(
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
  ) {
    const result = await axios.post<
      FlashyCreateContactResponse,
      AxiosResponse<FlashyCreateContactResponse>,
      CreateContactRequestBody
    >(
      APIService.URL.createFlashyContact,
      {
        firstName,
        lastName,
        email,
        phone,
      },
      this.getConfig()
    );
    return result.data.user;
  }

  public async createNewUser(
    contactID: string,
    firstName: string,
    lastName: string,
    email: string,
    phone: string,
  ) {
    const result = await axios.post<
      RegisterUserResponse,
      AxiosResponse<RegisterUserResponse>,
      RegisterUserRequest
    >(
      APIService.URL.createNewUser,
      {
        contactID,
        firstName,
        lastName,
        email,
        phone,
      },
      this.getConfig()
    );
    return result.data.user;
  }

  private getConfig() {
    const tokenHeader = this.token ? {token: this.token} : {};
    const config: AxiosRequestConfig = {
      baseURL: APIService.API_BASE,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...tokenHeader,
      }
    };

    return config;
  }
}